//import { Directive }          from '@angular/core';
import { Component, Input }     from '@angular/core';
import { Router }               from '@angular/router';
//import { OrgAuthService }       from '../auth/org/orgauth.service';
import { Referral }             from '../_models/referral';
import { ShareReferralService } from '../_services/index';
/*@Directive({
  selector: '[appReferralList]'
})*/

@Component({
  selector: 'referralorg-list',
  template: 
  `
    <span (click)='viewReferral()' class="handicon list-group-item" *ngIf="referral.action == 'VIEWREPORT' ">
      <a (click)='viewReport()' class="fa fa-bar-chart fa-lg mybtn-goldenrod" aria-hidden="true"></a> <a (click)='viewReferral()'   ng-class="hand wordWrap"><b>{{ referral.reflabel }} ( {{ referral.referencename }} ) for {{ referral.prefix }} {{ referral.firstname }} {{ referral.lastname }} ({{ referral.email }}) completed on {{referral.finishdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</b></a>
    </span>         
    <span (click)='viewReferral()' class="handicon list-group-item" *ngIf="referral.action == 'VIEW'  || referral.action == 'PENDING'  || referral.action == 'READY' ">
      <a (click)='viewReferral()' ng-class="hand wordWrap"><small><span [ngStyle]="{'color': referral.actionColor}" >{{ referral.actionText }}</span></small> {{ referral.reflabel }} ( {{ referral.referencename }} ) for {{ referral.prefix }} {{ referral.firstname }} {{ referral.lastname }} ({{ referral.email }}) started on  {{referral.startdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</a>
    </span>
    <span (click)='addReferrers()' class="handicon list-group-item" *ngIf="referral.action == 'ADDREFERRERS' ">
      <a (click)='addReferrers()' ng-class="hand wordWrap"><small><span [ngStyle]="{'color': referral.actionColor}" >{{ referral.actionText }}</span></small> {{ referral.reflabel }} ( {{ referral.referencename }} ) for {{ referral.prefix }} {{ referral.firstname }} {{ referral.lastname }} ({{ referral.email }}) started on  {{referral.startdate}} ( {{referral.totalresponses}} responses of {{referral.totalinvited}} invites ).</a>
    </span> 

    `
})


export class ReferralListOrgDirective {

  @Input()
  referral: Referral;
  
  constructor(
    private router: Router, 
    //private authOrg: OrgAuthService, 
    private shareReferral:ShareReferralService
    ) {}

  viewReport(){

    if (this.referral.referralid != ""){ //alert(this.referral.referralid);

        this.shareReferral.saveSelectedReferral(this.referral);         
        this.router.navigate(["/org/org-report-generator"]);
    }else{
        this.router.navigate(["/org/org-report-verification"]);
    }

  }

  viewReferral(){
    if (this.referral.referralid != ""){ //alert(this.referral.referralid);
        //this.router.navigate(['/report-generator', { id: this.referral.referralid} ]);      
        this.shareReferral.saveSelectedReferral(this.referral); 
        this.router.navigate(["/org/org-view-referral"]);           
        //this.router.navigate(["ind-add-referrers", this.referral.referralid]);   
    }else{
        this.router.navigate(["/org/org-home"]);
    }
    
  }

  addReferrers(){
    if (this.referral.referralid != ""){ //alert(this.referral.referralid);
        //this.router.navigate(['/report-generator', { id: this.referral.referralid} ]);      
        this.shareReferral.saveSelectedReferral(this.referral); 
        this.router.navigate(["/org/org-add-referrers"]);           
        //this.router.navigate(["ind-add-referrers", this.referral.referralid]);   
    }else{
        this.router.navigate(["/org/org-home"]);
    }

  }

}
